/* Fiche produit · « Elles ont adopté ALBA » (sections/obaia-videos.liquid)
   - Lecture automatique sans son quand une vidéo est visible à 50 %, pause hors de l’écran.
   - Bouton son : active le son de cette vidéo (et la relance si besoin), coupe celui des autres.
   - Clic sur la vidéo : lecture / pause.
   - « Réduire les animations » : rien ne se lance tout seul ; un clic lance la vidéo. */
OBAIA.section('videos', {
  init: function (root) {
    var T = window.OBAIA_T || {};
    var boites = OBAIA.$$('[data-vid]', root);
    var items = boites.map(function (box) {
      return { box: box, video: OBAIA.$('video', box), btn: OBAIA.$('[data-vid-son]', box), arret: false };
    });

    function jouer(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    function etat(it) { it.box.classList.toggle('is-arret', it.video.paused); }
    function son(it, actif) {
      it.video.muted = !actif;
      it.btn.setAttribute('aria-pressed', actif ? 'true' : 'false');
      it.btn.setAttribute('aria-label', actif ? (T.couper_son || 'Couper le son') : (T.activer_son || 'Activer le son'));
    }

    items.forEach(function (it) {
      etat(it);
      it.video.addEventListener('play', function () { etat(it); });
      it.video.addEventListener('pause', function () { etat(it); });
      it.btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var activer = it.video.muted;
        items.forEach(function (autre) { if (autre !== it) son(autre, false); });
        son(it, activer);
        if (activer && it.video.paused) { it.arret = false; jouer(it.video); }
      });
      it.box.addEventListener('click', function () {
        if (it.video.paused) { it.arret = false; jouer(it.video); }
        else { it.arret = true; it.video.pause(); }
      });
    });

    if (OBAIA.reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var it = items.find(function (x) { return x.box === e.target; });
        if (!it) return;
        if (e.isIntersecting && e.intersectionRatio >= 0.5) { if (!it.arret) jouer(it.video); }
        else if (!it.video.paused) { it.video.pause(); if (!it.video.muted) son(it, false); }
      });
    }, { threshold: [0, 0.5] });
    items.forEach(function (it) { io.observe(it.box); });
  }
});
